import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchCustomers, deleteCustomer } from './api';
import { CustomerRead } from './types';
import { AppPagination } from '../../../components/ui/AppPagination';
import { EditOutlined, DeleteOutline } from '@mui/icons-material';

const CustomersListPage: React.FC = () => {
  const navigate = useNavigate();
  const [customers, setCustomers] = useState<CustomerRead[]>([]);
  const [page, setPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const size = 15;

  const loadCustomers = async () => {
    try {
      const res = await fetchCustomers(page, size);
      setCustomers(res.items || []);
      setTotalItems(res.total || 0);
    } catch (err) {
      console.error('Ошибка загрузки заказчиков', err);
    }
  };

  useEffect(() => {
    loadCustomers();
  }, [page]);

  const handleDelete = async (id: number) => {
    if (!window.confirm('Вы уверены, что хотите удалить этого заказчика?')) return;
    try {
      await deleteCustomer(id);
      loadCustomers();
    } catch (err) {
      alert('Ошибка при удалении');
    }
  };

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold text-gray-800">Заказчики</h1>
        <button
          onClick={() => navigate('/organizations/customers/new')}
          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md font-medium shadow-sm transition-colors"
        >
          + Добавить заказчика
        </button>
      </div>

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Краткое наименование</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Полное наименование</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Телефон / Email</th>
              <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Действия</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {customers.map((customer) => (
              <tr key={customer.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 text-sm font-medium text-gray-900">{customer.short_name || '—'}</td>
                <td className="px-6 py-4 text-sm text-gray-500 max-w-xs truncate">{customer.full_name}</td>
                <td className="px-6 py-4 text-sm text-gray-500">
                  <div>{customer.phone || '—'}</div>
                  <div className="text-xs text-gray-400">{customer.email}</div>
                </td>
                <td className="px-6 py-4 text-right text-sm font-medium space-x-3">
                  <button onClick={() => navigate(`/organizations/customers/${customer.id}`)} className="text-blue-600 hover:text-blue-900">
                    <EditOutlined fontSize="small" />
                  </button>
                  <button onClick={() => handleDelete(customer.id)} className="text-red-600 hover:text-red-900">
                    <DeleteOutline fontSize="small" />
                  </button>
                </td>
              </tr>
            ))}
            {customers.length === 0 && (
              <tr>
                <td colSpan={4} className="px-6 py-10 text-center text-gray-500">Заказчики не найдены</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="mt-4">
        <AppPagination page={page} totalItems={totalItems} pageSize={size} onChange={setPage} />
      </div>
    </div>
  );
};

export default CustomersListPage;